import React from "react";
import OverviewTab from "./OverviewTab";

function OneTimeTab(props) {
  const items = (props.invoices || []).filter((i) => i.tip_plata === "ONE_TIME");
  return <OverviewTab {...props} invoices={items} />;
}

export default OneTimeTab;
